import { render, staticRenderFns } from "./ItemViewNotesEditor.vue?vue&type=template&id=774b6166&scoped=true&"
import script from "./ItemViewNotesEditor.vue?vue&type=script&lang=js&"
export * from "./ItemViewNotesEditor.vue?vue&type=script&lang=js&"
import style0 from "./ItemViewNotesEditor.vue?vue&type=style&index=0&id=774b6166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774b6166",
  null
  
)

export default component.exports